export const ADD_MESSAGE = 'app/FlashMessage/ADD_MESSAGE';
export const REMOVE_MESSAGE = 'app/FlashMessage/REMOVE_MESSAGE';
export const DEFAULT_VARIANT = 'info';
export const DEFAULT_ERROR_MESSAGE =
  'Oops, something went wrong. Please try again.';
